import fetchRequest from './fetchRequest';
import { type FetchResponseProps } from './types';

export default ({ URLs }): Promise<Array<FetchResponseProps>> => {
  const requests = URLs.map((URL) => fetchRequest(URL));

  return Promise.all(requests);
};
